import MessageIcon from '@material-ui/icons/Message';
import InboxIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import GroupIcon from '@material-ui/icons/Group';
import AppsIcon from '@material-ui/icons/Apps';


export const sidebarItems = [
    {
        icon: <MessageIcon/>,
        text: "Thread"
    },
    {
        icon: <InboxIcon/>,
        text: "All DMs"
    },
    {
        icon: <DraftsIcon/>,
        text: "Mentions & Reactions"
    },
    {
        icon: <BookmarkBorderIcon/>,
        text: "Save Items"
    },
    {
        icon: <GroupIcon/>,
        text: "Peoples & Groups"
    },
    {
        icon: <AppsIcon/>,
        text: "Thread"
    }

]
